module["exports"] = ["gmail.com", "hrnet.hr", "mailhr.hr"];